import { GlLink, GlIcon } from '@gitlab/ui';
import { __, sprintf } from '~/locale';
import issuableStateMixin from '../mixins/issuable_state';
export default {
    name: 'DiscussionLockedWidget',
    components: {
        GlIcon,
        GlLink
    },
    mixins: [
        issuableStateMixin
    ],
    props: {
        issuableType: {
            required: true,
            type: String
        }
    },
    computed: {
        issuableDisplayName () {
            return this.issuableType.replace(/_/g, ' ');
        },
        lockedIssueWarning () {
            return sprintf(__('The discussion in this %{issuableDisplayName} is locked. Only project members can comment.'), {
                issuableDisplayName: this.issuableDisplayName
            });
        }
    }
};
